/**
 * Extracts URL parameters and returns them as an object.
 *
 * @param {string} url - The URL string containing the query parameters.
 * @returns {Object<string, string>} - An object where keys are parameter names and values are their corresponding values.
 *
 * @example
 * const url = "?utm_source=affiliate&utm_campaign=1151&sub1=181&sub2=4c8fa3617d1f4e3a9e60d0f12a738504&sub3=&sub4=&sub5=&trid=e108d3df392949929bcde66eadddbd47&sourceid=&oid=19";
 * const params = getUrlParams(url);
 * // {
 * //   utm_source: "affiliate",
 * //   utm_campaign: "1151",
 * //   sub1: "181",
 * //   sub2: "4c8fa3617d1f4e3a9e60d0f12a738504",
 * //   sub3: "",
 * //   sub4: "",
 * //   sub5: "",
 * //   trid: "e108d3df392949929bcde66eadddbd47",
 * //   sourceid: "",
 * //   oid: "19"
 * // }
 */
export function getUrlParams(url) {
  const params = new URLSearchParams(url)
  /** @type {Object<string, string>} */
  const result = {}
  for (const [key, value] of params) {
    result[key] = value
  }
  return result
}
